import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["a", "strong", "b", "em", "i", "br"];
const ALLOWED_ATTR = ["href", "title", "target", "rel"];
// DOMPurify keeps the text of removed tags unless the tag is listed in FORBID_CONTENTS.
// In 2.x this option replaces the built-in list, so the defaults are repeated here.
const DROP_WITH_CONTENT = [
  "script", "style", "template", "iframe", "noscript", "noembed", "noframes", "xmp", "plaintext",
  "svg", "math", "audio", "video", "head", "title", "desc", "foreignobject", "annotation-xml",
  "colgroup", "thead", "mi", "mn", "mo", "ms", "mtext",
  "div", "span", "section", "table", "form", "h1", "h2", "h3", "h4", "h5", "h6",
];

// Strip <p> wrappers, then keep only inline text-formatting tags and safe links.
// Hidden blocks (e.g. <div style="display:none">) and scripts are dropped with their content.
export const sanitizeInlineHtml = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(String(html).replace(/<\/?p>/gi, ""), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
    FORBID_CONTENTS: DROP_WITH_CONTENT,
  });
};
